import { EvStationIcon } from './EvStationIcon';

/**
 * author: Google
 * id 7C859DE1-16F6-4EF2-9097-A1D0C14CC3A2
 * name ev-station
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ev-station.svg
 * tags
 * - Places 
 * - Automotive 
 */
export const WallChargerIcon = EvStationIcon;
export default WallChargerIcon